module.exports = __webpack_public_path__ + "img/xd-logo.207a6b48.svg";